const supports = [
  {
    icon: "ri-smartphone-line",
    title: "スマホで使える「お金の記録アプリ」サポート",
    badge: "初心者にやさしい",
    desc: "「クラウド会計」とは、レシートをスマホで写真に撮るだけで、自動でお金の記録をつけてくれる便利なアプリのこと。難しい用語はゼロ。設定から使い方まで丁寧にサポートします。対応：弥生会計・freeeなど",
  },
  {
    icon: "ri-discuss-line",
    title: "経営相談",
    badge: "安心のサポート",
    desc: "数字の読み方がわからない、売上は上がっているのに手元にお金が残らない……そんな経営上の疑問や不安を、気軽に話せる相手がZenwestです。年2回の定期相談をはじめ、日常的なご相談にも対応します。",
  },
  {
    icon: "ri-store-2-line",
    title: "サロンのホームページ制作",
    badge: "集客強化",
    desc: "「インスタだけじゃ不安」「Googleで検索されるようなサイトがほしい」というオーナーさんへ。集客に強いホームページを制作し、その後のメンテナンスまでサポートします。",
  },
];

export default function ITSupport() {
  return (
    <section className="py-24 bg-white" id="it-support">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          <div className="relative order-2 lg:order-1">
            <div className="absolute inset-0 bg-gradient-to-br from-[#0EA5E9]/10 to-[#1A2332]/10 rounded-3xl blur-3xl"></div>
            <img
              src="https://public.readdy.ai/ai/img_res/3421f6c54dbe6f888e9b01c8fff39769.jpg"
              alt="サロン向けITサポート"
              className="relative w-full h-[620px] object-cover object-top rounded-3xl"
            />
          </div>

          <div className="order-1 lg:order-2">
            <p className="text-[#0EA5E9] text-sm font-semibold tracking-widest mb-4">IT SUPPORT</p>
            <h2 className="text-3xl font-extrabold text-[#1A2332] leading-tight mb-6">
              記帳だけじゃない。<br />
              サロンのデジタル化を<br />
              まるごとサポート。
            </h2>

            <p className="text-base text-gray-500 leading-relaxed mb-10">
              「パソコンが苦手」でも大丈夫。Zenwestは専門用語を使わず、わかりやすくご説明しながら、サロン経営に必要なデジタル環境を一緒に整えます。
            </p>

            <div className="space-y-7">
              {supports.map((item, i) => (
                <div key={i} className="flex gap-5 items-start group">
                  <div className="w-12 h-12 flex-shrink-0 flex items-center justify-center bg-[#EFF8FF] group-hover:bg-[#0EA5E9] rounded-xl transition-colors duration-300">
                    <i className={`${item.icon} text-xl text-[#0EA5E9] group-hover:text-white transition-colors duration-300`}></i>
                  </div>
                  <div>
                    <div className="flex items-center gap-3 mb-1">
                      <h3 className="text-base font-bold text-[#1A2332]">{item.title}</h3>
                      <span className="text-xs text-[#0EA5E9] bg-[#EFF8FF] px-2 py-0.5 rounded-full whitespace-nowrap font-medium">{item.badge}</span>
                    </div>
                    <p className="text-base text-gray-500 leading-relaxed">{item.desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
